import { Associate } from '../associates/associate.model';
import { Employee } from '../associates/employee.model';
import { ServiceGroup } from './service-group.model';
import { TechnicianGroup } from '../associates/technician-group.model';
import { WarrantySubmissionType } from './warranty-submission-type.model';
import { WorkOrder } from './work-order.model';
import { WorkOrderLabour } from './work-order-labour.model';
import { WorkOrderRequestSub } from './work-order-request-sub.model';
export class WorkOrderCase {
  addedByPowerlane?: boolean = null;
  addedFromServiceSchedule?: boolean = null;
  addedOpFlag: string = null;
  allowMultipleTechFlag: string = null;
  approvedFlag: string = null;
  autoCreatedByPartner: string = null;
  campaignAddedBySystem: string = null;
  campaignNumber: string = null;
  caseMovedFrom: number = null;
  caseStatusId: string = null;
  cause: string = null;
  chargeoutRateBasisId: number = null;
  claimTypeId: number = null;
  complaintCodeId: string = null;
  complaintTypeId: string = null;
  concernCategoryId: number = null;
  concernCode: number = null;
  concernSubCategory: number = null;
  conditionCode: number = null;
  customerDecision: string = null;
  customerDecisionDeclineReason: string = null;
  embedded?: WorkOrderCaseEmbed;
  employeeId: string = null;
  estimatedTime: number = null;
  expectedTime: number = null;
  holdTimeDateEntered: Date = null;
  holdTimeInHours: number = null;
  holdUntilDate: Date = null;
  id: number = null;
  internalTransTypeId: string = null;
  labourOpFlag: string = null;
  labourOp: string = null;
  mergedWithQuote: boolean = null;
  mileageInterval: number = null;
  modifiedByTechnicianWorkbench?: boolean = null;
  monthInterval: number = null;
  nissanCoverageCodeId: number = null;
  nissanDiagnosisCodeId: number = null;
  nissanSymptomCodeId: number = null;
  note: string = null;
  originalCause: string = null;
  originalTechnicianStory: string = null;
  partKitsMaintenanceId: number = null;
  printedFlag: string = null;
  recommendedHours: number = null;
  refusalCode: number = null;
  repairCode: string = null;
  sequence: number = null;
  serviceGroupId: string = null;
  shopFlag: string = null;
  shopSupplyFlag: string = null;
  startTime: Date = null;
  t1Code: string = null;
  t2Code: string = null;
  technicianGroupId: number = null;
  technicianGroupName: string = null;
  technicianId: string = null;
  technicianRateBasisId: number = null;
  technicianStory: string = null;
  thirdPartyWarrantyFlag: string = null;
  transitDamageCode: string = null;
  volkswagenRemovedPart: string = null;
  warrantyClaimTypeId: string = null;
  warrantySubmissionTypeId: string = null;
  warrantyTransactionCategoryId: number = null;
  workOrderId: number = null;
  // holdUntilDate?: Date = null;
  holdTimeEntered?: Date = null;
  //holdTimeInHours?: Date = null;

  constructor(obj?: WorkOrderCase) {
    if (obj) {
      Object.assign(this, obj);
    }
  }
}

class WorkOrderCaseEmbed {
  employee?: Employee = null;
  serviceGroup?: ServiceGroup = null;
  technicianAssociate?: Associate = null;
  technicianEmployee?: Employee = null;
  technicianGroup?: TechnicianGroup = null;
  warrantySubmissionType?: WarrantySubmissionType = null;
  labour?: WorkOrderLabour = null;
  requestSub?: WorkOrderRequestSub = null;
  workOrder?: WorkOrder = null;
}
